import script from "./DeleteDashboardDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./DeleteDashboardDialog.vue?vue&type=script&setup=true&lang=js"

import "./DeleteDashboardDialog.vue?vue&type=style&index=0&id=0ee7d002&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0ee7d002"]])

export default __exports__